module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/service-items/service-items-page/service-items-page.component.css
// module id = ./src/app/components/service-items/service-items-page/service-items-page.component.css
// module chunks = main